import { createAction } from 'redux-actions';

// action types
export const SET_INITIAL_USER = 'SET_INITIAL_USER';
export const FLOW_USER_AUTHENTICATED = 'FLOW_USER_AUTHENTICATED';

// actions
export const setInitialUser = createAction(SET_INITIAL_USER);
export const flowUserAuthenticated = createAction(FLOW_USER_AUTHENTICATED);
